import { gql } from '@grandvisionhq/graphql';

const appointmentFragment = gql`
  fragment AppointmentFragment on Appointment {
    id
    status
    invitee {
      firstName
      lastName
      email
      phone
    }
    child {
      firstName
      lastName
      dateOfBirth
    }
    isReservation
    preferredChannelOfCommunication
    appointmentType {
      id
      name
      ageGroup
      description
      duration {
        amount
        unit
      }
      visibleToCustomers
    }
    startTime
    endTime
    store {
      code
    }
    customerComment
  }
`;

export { appointmentFragment };
//# sourceMappingURL=appointment.js.map
